/**
 * Requires
 */

import $ from 'jquery'

/**
 * Initialisation
 */

export function initialise() {
  readQueryString()
}

function readQueryString() {
  const urlParams = new URLSearchParams(window.location.search)
  const token = urlParams.get('accessToken')

  if (token) {
    const existingTokens = getExistingTokens() // Get existing tokens from the cookie
    const tokens = existingTokens ? existingTokens.split(',') : [] // Convert existing tokens to an array

    if (!tokens.includes(token)) {
      tokens.push(token) // Add the new token to the array if it doesn't already exist
      const cookieValues = tokens.join(',') // Combine tokens into a comma-separated string

      document.cookie = `accessToken=${cookieValues};path=/;` // Set cookie
      // reload the page
      document.location.reload()
    }
  }
}

function getExistingTokens() {
  const cookies = document.cookie.split(';') // Get all cookies
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim()
    if (cookie.startsWith('accessToken=')) {
      return cookie.substring(13) // Return the value of the existing accessToken cookie
    }
  }
  return null // Return null if the accessToken cookie doesn't exist
}
